// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1gJed","itemTitle":"ClientEmergencyInfo_itemTitle__nUbKa","itemText":"ClientEmergencyInfo_itemText__1wRaQ"};